<div class="skeleton-specs-container">
	@for (item of [0,0,0]; track trackbyFn($index)) {
		<div class="skeleton-specs-item hmf-p-s">
			<div class="specs-box">
				<div class="spec-name-placeholder skeleton-grey-loading-animation hmf-mb-xxs"></div>
				<div class="spec-value-placeholder skeleton-grey-loading-animation"></div>
			</div>
		</div>
	}
</div>
